// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as Jotai from "jotai";
import * as React from "react";
import * as TftSet from "common/src/data/TftSet.bs.js";
import * as TbAtoms from "./TbAtoms.bs.js";
import * as UnitImage from "common/src/tft-static/UnitImage.bs.js";
import * as ReactDnd from "react-dnd";
import * as Translation from "common/src/bindings/Translation.bs.js";
import * as UnitTooltip from "common/src/tft-static/UnitTooltip.bs.js";

function TbUnitSource(Props) {
  var searchMatch = Props.searchMatch;
  var highlight = Props.highlight;
  var unit = Props.unit;
  var size = Props.size;
  var sizeSm = Props.sizeSm;
  var sizeMd = Props.sizeMd;
  var onClick = Props.onClick;
  Translation.useT(/* Units */1);
  TftSet.use(undefined);
  var match = Jotai.useAtom(TbAtoms.useSkins);
  var match$1 = Jotai.useAtom(TbAtoms.disableTooltips);
  var match$2 = ReactDnd.useDrag({
        type: "unit",
        item: {
          id: unit,
          type: "unit"
        }
      });
  return React.createElement("div", {
              className: "transition-opacity " + (
                searchMatch && highlight ? "" : "opacity-30"
              ),
              onClick: (function (param) {
                  return Curry._1(onClick, unit);
                })
            }, React.createElement(UnitTooltip.make, {
                  disabled: match$1[0],
                  unit: unit,
                  children: React.createElement("div", {
                        ref: match$2[1],
                        className: "cursor-pointer",
                        onDragStart: (function (e) {
                            return e.preventDefault();
                          })
                      }, React.createElement(UnitImage.make, {
                            skin: match[0],
                            unitId: unit,
                            size: size,
                            sizeSm: sizeSm,
                            sizeMd: sizeMd
                          }))
                }));
}

var make = TbUnitSource;

export {
  make ,
  
}
/* jotai Not a pure module */
